import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { H5 } from '@liveauctioneers/hammer-ui-core/text';
import { OtherCategory } from '@/types/categories/categories';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import React, { ReactElement } from 'react';
import styled from 'styled-components';

export type OtherCategoryCardProps = {
    category: OtherCategory;
};

const OtherCategoryCard = ({ category }: OtherCategoryCardProps): ReactElement => {
    return (
        <StyledCard>
            <H5>{category.title}</H5>
            <StyledDivider />
            {category.subCategories.map((subCategory) => (
                <StyledCategory key={subCategory.title}>
                    <Link
                        secondary
                        target="_blank"
                        to={subCategory.pageUrl}
                    >
                        {subCategory.title}
                    </Link>
                </StyledCategory>
            ))}
            <Link
                target="_blank"
                to={category.pageUrl}
            >
                <FormattedMessage id="discoverPage.otherCategories.viewAllItems" />
            </Link>
        </StyledCard>
    );
};

export default OtherCategoryCard;

const StyledCard = styled.article`
    width: 286px;
    margin: 0 -3px 32px 0;

    a {
        font-size: 16px;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }
`;

const StyledDivider = styled.hr`
    margin-top: 8px;
`;

const StyledCategory = styled.div`
    margin: 8px auto;
    display: flex;
    flex-wrap: wrap;

    a {
        color: ${({ theme }) => theme.colors.black};
    }
`;
